export default __webpack_public_path__ + "static/media/mood.ce6f7df0.png";